"use client";

import { useState, useEffect } from "react";
import { FaTextHeight, FaMinus, FaPlus } from "react-icons/fa6";

export default function FontSizeController() {
  const [fontSize, setFontSize] = useState(100); // percentage
  const step = 10;
  const min = 70;
  const max = 150;

  useEffect(() => {
    // Get saved font size from localStorage
    const savedFontSize = localStorage.getItem("appFontSize");
    if (savedFontSize) {
      setFontSize(parseInt(savedFontSize));
      document.documentElement.style.fontSize = `${savedFontSize}%`;
    }
  }, []);

  const handleFontSizeChange = (newSize: number) => {
    // Constrain to min/max
    const constrainedSize = Math.max(min, Math.min(max, newSize));
    setFontSize(constrainedSize);
    // Apply to root element
    document.documentElement.style.fontSize = `${constrainedSize}%`;
    // Save to localStorage
    localStorage.setItem("appFontSize", constrainedSize.toString());
  };

  const increaseSize = () => handleFontSizeChange(fontSize + step);
  const decreaseSize = () => handleFontSizeChange(fontSize - step);
  const resetFontSize = () => handleFontSizeChange(100);

  return (
    <div className="dropdown dropdown-end">
      <div
        tabIndex={0}
        role="button"
        className="btn btn-ghost btn-circle"
        title="Adjust font size"
      >
        <div className="lg:tooltip lg:tooltip-left lg:tooltip-primary font-normal" data-tip="Font size">
          <div tabIndex={0} role="button" className="btn btn-ghost btn-circle">
            <FaTextHeight className="h-4 w-4" aria-label="Font size icon" />
          </div>
        </div>
      </div>
      <div
        tabIndex={0}
        className="dropdown-content bg-base-100 rounded-box z-50 mt-3 p-4 shadow-lg border border-base-200 w-64"
      >
        <div className="flex items-center justify-between">
          <div className="lg:tooltip lg:tooltip-bottom lg:tooltip-primary" data-tip="Decrease">
            <button
              onClick={decreaseSize}
              className="btn btn-circle btn-outline btn-sm"
              disabled={fontSize <= min}
              aria-label="Decrease"
            >
              <FaMinus className="h-3 w-3" />
            </button>
          </div>

          <div className="font-bold text-center mx-2">
            {fontSize === 100 ? (
              <span>Font size: 100%</span>
            ) : (
              <span>Font size: {fontSize}%</span>
            )}
          </div>

          <div className="lg:tooltip lg:tooltip-bottom lg:tooltip-primary" data-tip="Increase">
            <button
              onClick={increaseSize}
              className="btn btn-circle btn-outline btn-sm"
              disabled={fontSize >= max}
              aria-label="Increase"
            >
              <FaPlus className="h-3 w-3" />
            </button>
          </div>
        </div>

        {/* Reset button */}
        <div className="text-center mt-4">
          <button
            onClick={resetFontSize}
            className="btn btn-sm btn-outline"
            disabled={fontSize === 100}
          >
            Default
          </button>
        </div>
      </div>
    </div>
  );
}
